// AUTO-GENERATED by scripts/generate-search-types.mjs — do not edit by hand.
// Derived from the product_type:"..." values in src/lib/categories.ts.
// Sorted longest-alias-first so the most specific phrase wins.

export const SEARCH_TYPE_ALIASES: ReadonlyArray<readonly [alias: string, productType: string]> = [
  ["deck boxes and outdoor/utility storage", "Deck Boxes and Outdoor/Utility Storage"],
  ["outdoor accessories-decor-garden-games", "Outdoor Accessories-Decor-Garden-Games"],
  ["outdoor accessories-decor-garden-game", "Outdoor Accessories-Decor-Garden-Games"],
  ["outdoor furniture - conversation sets", "Outdoor Furniture - Conversation Sets"],
  ["outdoor furniture - conversation set", "Outdoor Furniture - Conversation Sets"],
  ["foam, spring and hybrid mattresses", "Foam, Spring And Hybrid Mattresses"],
  ["foam, spring and hybrid mattress", "Foam, Spring And Hybrid Mattresses"],
  ["bathroom storage & organization", "Bathroom Storage & Organization"],
  ["outdoor fireplaces and firepits", "Outdoor Fireplaces and Firepits"],
  ["outdoor fireplaces and firepit", "Outdoor Fireplaces and Firepits"],
  ["nightstands & bedside tables", "Nightstands & Bedside Tables"],
  ["artificial plants and trees", "Artificial Plants and Trees"],
  ["nightstands & bedside table", "Nightstands & Bedside Tables"],
  ["artificial plants and tree", "Artificial Plants and Trees"],
  ["down comforters and duvets", "Down Comforters and Duvets"],
  ["blanket racks and ladders", "Blanket Racks and Ladders"],
  ["down comforters and duvet", "Down Comforters and Duvets"],
  ["outdoor throws & blankets", "Outdoor Throws & Blankets"],
  ["blanket racks and ladder", "Blanket Racks and Ladders"],
  ["outdoor throws & blanket", "Outdoor Throws & Blankets"],
  ["bar & restaurant tables", "Bar & Restaurant Tables"],
  ["outdoor privacy screens", "Outdoor Privacy Screens"],
  ["outdoor/utility storage", "Deck Boxes and Outdoor/Utility Storage"],
  ["pendants-hanging lights", "Pendants-Hanging Lights"],
  ["umbrella stands & bases", "Umbrella Stands & Bases"],
  ["bar & restaurant table", "Bar & Restaurant Tables"],
  ["bedroom furniture sets", "Bedroom Furniture Sets"],
  ["outdoor hanging lights", "Outdoor Hanging Lights"],
  ["outdoor privacy screen", "Outdoor Privacy Screens"],
  ["pendants-hanging light", "Pendants-Hanging Lights"],
  ["umbrella stands & base", "Umbrella Stands & Bases"],
  ["bar carts and servers", "Bar Carts and Servers"],
  ["barware and drinkware", "Barware and Drinkware"],
  ["bedroom furniture set", "Bedroom Furniture Sets"],
  ["comforters and quilts", "Comforters and Quilts"],
  ["ergonomic accessories", "Ergonomic Accessories"],
  ["kitchen carts-islands", "Kitchen Carts-Islands"],
  ["outdoor hanging light", "Outdoor Hanging Lights"],
  ["accent throw pillows", "Accent Throw Pillows"],
  ["bar carts and server", "Bar Carts and Servers"],
  ["comforters and quilt", "Comforters and Quilts"],
  ["ergonomic accessorie", "Ergonomic Accessories"],
  ["fire pit accessories", "Fire Pit Accessories"],
  ["kitchen carts-island", "Kitchen Carts-Islands"],
  ["peel and stick tiles", "Peel and Stick Tiles"],
  ["wall mounted shelves", "Wall Mounted Shelves"],
  ["accent throw pillow", "Accent Throw Pillows"],
  ["christmas ornaments", "Christmas Ornaments"],
  ["curtains and drapes", "Curtains and Drapes"],
  ["fire pit accessorie", "Fire Pit Accessories"],
  ["kitchen accessories", "Kitchen Accessories"],
  ["mattress protectors", "Mattress Protectors"],
  ["outdoor accessories", "Outdoor Accessories-Decor-Garden-Games"],
  ["peel and stick tile", "Peel and Stick Tiles"],
  ["wall mounted shelve", "Wall Mounted Shelves"],
  ["christmas ornament", "Christmas Ornaments"],
  ["curtains and drape", "Curtains and Drapes"],
  ["kitchen accessorie", "Kitchen Accessories"],
  ["mattress protector", "Mattress Protectors"],
  ["outdoor accessorie", "Outdoor Accessories-Decor-Garden-Games"],
  ["outdoor bar chairs", "Outdoor Bar Chairs"],
  ["outdoor dining set", "Outdoor Dining Set"],
  ["outdoor fireplaces", "Outdoor Fireplaces and Firepits"],
  ["outdoor sectionals", "Outdoor Sectionals"],
  ["artificial plants", "Artificial Plants and Trees"],
  ["bathroom vanities", "Bathroom Vanities"],
  ["conversation sets", "Outdoor Furniture - Conversation Sets"],
  ["hybrid mattresses", "Foam, Spring And Hybrid Mattresses"],
  ["outdoor bar chair", "Outdoor Bar Chairs"],
  ["outdoor fireplace", "Outdoor Fireplaces and Firepits"],
  ["outdoor furniture", "Outdoor Furniture - Conversation Sets"],
  ["outdoor sectional", "Outdoor Sectionals"],
  ["outdoor umbrellas", "Outdoor Umbrellas"],
  ["restaurant tables", "Bar & Restaurant Tables"],
  ["throws & blankets", "Throws & Blankets"],
  ["artificial plant", "Artificial Plants and Trees"],
  ["bath accessories", "Bath Accessories"],
  ["bathroom storage", "Bathroom Storage & Organization"],
  ["bathroom vanitie", "Bathroom Vanities"],
  ["ceiling lighting", "Ceiling Lighting"],
  ["conversation set", "Outdoor Furniture - Conversation Sets"],
  ["mattress toppers", "Mattress Toppers"],
  ["outdoor lighting", "Outdoor Lighting"],
  ["outdoor ottomans", "Outdoor Ottomans"],
  ["outdoor planters", "Outdoor Planters"],
  ["outdoor umbrella", "Outdoor Umbrellas"],
  ["restaurant table", "Bar & Restaurant Tables"],
  ["throws & blanket", "Throws & Blankets"],
  ["bath accessorie", "Bath Accessories"],
  ["christmas trees", "Christmas Trees"],
  ["down comforters", "Down Comforters and Duvets"],
  ["end-side tables", "End-Side Tables"],
  ["filing cabinets", "Filing Cabinets"],
  ["hybrid mattress", "Foam, Spring And Hybrid Mattresses"],
  ["indoor planters", "Indoor Planters"],
  ["mattress topper", "Mattress Toppers"],
  ["outdoor benches", "Outdoor Benches"],
  ["outdoor heaters", "Outdoor Heaters"],
  ["outdoor ottoman", "Outdoor Ottomans"],
  ["outdoor pillows", "Outdoor Pillows"],
  ["outdoor planter", "Outdoor Planters"],
  ["pantry cabinets", "Pantry Cabinets"],
  ["shower curtains", "Shower Curtains"],
  ["umbrella stands", "Umbrella Stands & Bases"],
  ["bedside tables", "Nightstands & Bedside Tables"],
  ["candle holders", "Candle Holders"],
  ["christmas tree", "Christmas Trees"],
  ["console tables", "Console Tables"],
  ["counter stools", "Bar Chairs"],
  ["down comforter", "Down Comforters and Duvets"],
  ["end-side table", "End-Side Tables"],
  ["filing cabinet", "Filing Cabinets"],
  ["hanging lights", "Pendants-Hanging Lights"],
  ["indoor planter", "Indoor Planters"],
  ["outdoor chairs", "Outdoor Chairs"],
  ["outdoor gazebo", "Outdoor Gazebo"],
  ["outdoor heater", "Outdoor Heaters"],
  ["outdoor pillow", "Outdoor Pillows"],
  ["outdoor tables", "Outdoor Tables"],
  ["outdoor throws", "Outdoor Throws & Blankets"],
  ["pantry cabinet", "Pantry Cabinets"],
  ["picture frames", "Picture Frames"],
  ["rocking chairs", "Rocking Chairs"],
  ["shower benches", "Shower Benches"],
  ["shower curtain", "Shower Curtains"],
  ["umbrella stand", "Umbrella Stands & Bases"],
  ["accent chairs", "Accent Chairs"],
  ["bedside table", "Nightstands & Bedside Tables"],
  ["blanket racks", "Blanket Racks and Ladders"],
  ["candle holder", "Candle Holders"],
  ["coffee tables", "Coffee Tables"],
  ["console table", "Console Tables"],
  ["counter stool", "Bar Chairs"],
  ["dining chairs", "Dining Chairs"],
  ["dining linens", "Dining Linens"],
  ["dining tables", "Dining Tables"],
  ["hanging light", "Pendants-Hanging Lights"],
  ["jewelry boxes", "Jewelry Boxes"],
  ["kitchen carts", "Kitchen Carts-Islands"],
  ["luggage racks", "Luggage Racks"],
  ["office chairs", "Office Chairs"],
  ["outdoor bench", "Outdoor Benches"],
  ["outdoor chair", "Outdoor Chairs"],
  ["outdoor sofas", "Outdoor Sofas"],
  ["outdoor table", "Outdoor Tables"],
  ["outdoor throw", "Outdoor Throws & Blankets"],
  ["picture frame", "Picture Frames"],
  ["rocking chair", "Rocking Chairs"],
  ["room dividers", "Room Dividers"],
  ["seat cushions", "Seat Cushions"],
  ["serving bowls", "Serving Bowls"],
  ["smoker barrel", "Smoker Barrel"],
  ["standard beds", "Standard Beds"],
  ["vanity tables", "Vanity Tables"],
  ["wall lighting", "Wall Lighting"],
  ["accent chair", "Accent Chairs"],
  ["air mattress", "Air Mattress"],
  ["blanket rack", "Blanket Racks and Ladders"],
  ["coat hangers", "Coat Hangers"],
  ["coffee table", "Coffee Tables"],
  ["dining chair", "Dining Chairs"],
  ["dining linen", "Dining Linens"],
  ["dining table", "Dining Tables"],
  ["floor chairs", "Floor Chairs"],
  ["foam, spring", "Foam, Spring And Hybrid Mattresses"],
  ["kitchen cart", "Kitchen Carts-Islands"],
  ["luggage rack", "Luggage Racks"],
  ["office chair", "Office Chairs"],
  ["outdoor rugs", "Outdoor Rugs"],
  ["outdoor sofa", "Outdoor Sofas"],
  ["room divider", "Room Dividers"],
  ["seat cushion", "Seat Cushions"],
  ["seating sets", "Seating Sets"],
  ["serving bowl", "Serving Bowls"],
  ["shower bench", "Shower Benches"],
  ["shower doors", "Shower Doors"],
  ["standard bed", "Standard Beds"],
  ["vanity table", "Vanity Tables"],
  ["wine coolers", "Wine Coolers"],
  ["bed pillows", "Bed Pillows"],
  ["chandeliers", "Chandeliers"],
  ["coat hanger", "Coat Hangers"],
  ["desk chairs", "Office Chairs"],
  ["dining sets", "Dining Sets"],
  ["floor chair", "Floor Chairs"],
  ["floor lamps", "Floor Lamps"],
  ["jewelry box", "Jewelry Boxes"],
  ["kids chairs", "Kids Chairs"],
  ["nightstands", "Nightstands & Bedside Tables"],
  ["outdoor rug", "Outdoor Rugs"],
  ["seating set", "Seating Sets"],
  ["shower door", "Shower Doors"],
  ["side tables", "End-Side Tables"],
  ["stick tiles", "Peel and Stick Tiles"],
  ["table lamps", "Table Lamps"],
  ["tray tables", "Tray Tables"],
  ["wall clocks", "Wall Clocks"],
  ["wall panels", "Wall Panels"],
  ["wine cooler", "Wine Coolers"],
  ["bar chairs", "Bar Chairs"],
  ["bar stools", "Bar Chairs"],
  ["bed frames", "Standard Beds"],
  ["bed pillow", "Bed Pillows"],
  ["bed sheets", "Bed Sheets"],
  ["chandelier", "Chandeliers"],
  ["deck boxes", "Deck Boxes and Outdoor/Utility Storage"],
  ["desk chair", "Office Chairs"],
  ["dining set", "Dining Sets"],
  ["dinnerware", "Dinnerware"],
  ["fireplaces", "Fireplaces"],
  ["floor lamp", "Floor Lamps"],
  ["headboards", "Headboards"],
  ["kids chair", "Kids Chairs"],
  ["lampshades", "Lampshades"],
  ["love seats", "Love Seats"],
  ["nightstand", "Nightstands & Bedside Tables"],
  ["sculptures", "Sculptures"],
  ["sectionals", "Sectionals"],
  ["shoe racks", "Shoe Racks"],
  ["side table", "End-Side Tables"],
  ["sideboards", "Sideboards"],
  ["stick tile", "Peel and Stick Tiles"],
  ["table lamp", "Table Lamps"],
  ["tray table", "Tray Tables"],
  ["wall clock", "Wall Clocks"],
  ["wall decor", "Wall Decor"],
  ["wall panel", "Wall Panels"],
  ["area rugs", "Area Rugs"],
  ["bar carts", "Bar Carts and Servers"],
  ["bar chair", "Bar Chairs"],
  ["bar stool", "Bar Chairs"],
  ["bar tools", "Bar Tools"],
  ["bath rugs", "Bath Rugs"],
  ["bed frame", "Standard Beds"],
  ["bed sheet", "Bed Sheets"],
  ["bookcases", "Bookcases"],
  ["bunk beds", "Bunk Beds"],
  ["drinkware", "Barware and Drinkware"],
  ["fireplace", "Fireplaces"],
  ["headboard", "Headboards"],
  ["lampshade", "Lampshades"],
  ["loft beds", "Loft Beds"],
  ["love seat", "Love Seats"],
  ["pet bowls", "Pet Bowls"],
  ["recliners", "Recliners"],
  ["sculpture", "Sculptures"],
  ["sectional", "Sectionals"],
  ["shoe rack", "Shoe Racks"],
  ["sideboard", "Sideboards"],
  ["tv stands", "TV Stands"],
  ["area rug", "Area Rugs"],
  ["bar cart", "Bar Carts and Servers"],
  ["bar tool", "Bar Tools"],
  ["bath rug", "Bath Rugs"],
  ["blankets", "Outdoor Throws & Blankets"],
  ["bookcase", "Bookcases"],
  ["bunk bed", "Bunk Beds"],
  ["cabinets", "Cabinets"],
  ["curtains", "Curtains and Drapes"],
  ["deck box", "Deck Boxes and Outdoor/Utility Storage"],
  ["dog beds", "Dog Beds"],
  ["doormats", "Doormats"],
  ["dressers", "Dressers"],
  ["firepits", "Outdoor Fireplaces and Firepits"],
  ["flatware", "Flatware"],
  ["hammocks", "Hammocks"],
  ["loft bed", "Loft Beds"],
  ["ottomans", "Ottomans"],
  ["pendants", "Pendants-Hanging Lights"],
  ["pet bowl", "Pet Bowls"],
  ["recliner", "Recliners"],
  ["rug pads", "Rug Pads"],
  ["tv stand", "TV Stands"],
  ["wall art", "Wall Art"],
  ["barware", "Barware and Drinkware"],
  ["benches", "Benches"],
  ["blanket", "Outdoor Throws & Blankets"],
  ["cabinet", "Cabinets"],
  ["candles", "Candles"],
  ["couches", "Sofas"],
  ["curtain", "Curtains and Drapes"],
  ["dog bed", "Dog Beds"],
  ["doormat", "Doormats"],
  ["dresser", "Dressers"],
  ["firepit", "Outdoor Fireplaces and Firepits"],
  ["hammock", "Hammocks"],
  ["mirrors", "Mirrors"],
  ["ottoman", "Ottomans"],
  ["pendant", "Pendants-Hanging Lights"],
  ["rug pad", "Rug Pads"],
  ["servers", "Bar Carts and Servers"],
  ["wreaths", "Wreaths"],
  ["candle", "Candles"],
  ["drapes", "Curtains and Drapes"],
  ["duvets", "Down Comforters and Duvets"],
  ["mirror", "Mirrors"],
  ["server", "Bar Carts and Servers"],
  ["throws", "Throws & Blankets"],
  ["wreath", "Wreaths"],
  ["bench", "Benches"],
  ["couch", "Sofas"],
  ["desks", "Desks"],
  ["drape", "Curtains and Drapes"],
  ["duvet", "Down Comforters and Duvets"],
  ["sofas", "Sofas"],
  ["throw", "Throws & Blankets"],
  ["trays", "Trays"],
  ["trees", "Artificial Plants and Trees"],
  ["vases", "Vases"],
  ["beds", "Standard Beds"],
  ["desk", "Desks"],
  ["game", "Outdoor Accessories-Decor-Garden-Games"],
  ["sofa", "Sofas"],
  ["tray", "Trays"],
  ["tree", "Artificial Plants and Trees"],
  ["vase", "Vases"],
  ["bar", "Bar & Restaurant Tables"],
  ["bed", "Standard Beds"],
  ["end", "End-Side Tables"],
];

/** Returns the longest alias present in the query, or null. */
export function matchProductTypeAlias(query: string): { alias: string; productType: string } | null {
  const q = ` ${query.toLowerCase().replace(/[^a-z0-9&'\s-]/g, ' ').replace(/\s+/g, ' ').trim()} `;
  for (const [alias, productType] of SEARCH_TYPE_ALIASES) {
    if (q.includes(` ${alias} `)) return { alias, productType };
  }
  return null;
}
